import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ICONS } from '../../../../assets/icons';
import SendInbox from '../../../../assets/customSVG/inbox/SendInbox';
import NoData from 'components/commonComponents/Nodata/index';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import ChatHeader from './ChatHeader';
import { useSelector, useDispatch } from 'react-redux';
import { Avatar, Badge, Divider, Typography } from 'antd';
import TextMessage from './InboxUtils/Message/TextMessage';
import ConversationMessage from './InboxUtils/Message/Index';
import ChatBoxFooter from './InboxUtils/ChatFooter/ChatBoxFooter';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  fetchWebChatConversationMessages,
  markTeamAsRead,
  markConversationAsRead,
  updatedSelectedConversationLastReadMessageId,
} from '../../../../reduxToolkit/inboxSlice';
import {
  ArrowDownOutlined,
  DoubleLeftOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import { useSocket } from 'providers/SocketProvider';

const { Text, Title } = Typography;

const ChatBox = ({ className }) => {
  const dispatch = useDispatch();
  const { sendReadEvent, sendChatEvent } = useSocket();

  const {
    webChatConversationMessages,
    selectedWebChatConversation,
    webChatMessagesCount,
    selectedWebChatTeam,
    lastMessageId,
    lastSocketConversationMessage,
    webChatConversationMessagesLoading,
  } = useSelector((state) => state?.inbox);
  const { currentBrand } = useSelector((state) => state?.app);
  const { read_record_id, last_read_message_id } = selectedWebChatConversation;

  const [page, setPage] = useState(1);
  const [limit] = useState(40);
  const [showScrollToBottom, setShowScrollToBottom] = useState(false);
  const [newMessageCount, setNewMessageCount] = useState(0);
  const [showUnreadDivider, setShowUnreadDivider] = useState(false);
  const [unreadDividerMessageId, setUnreadDividerMessageId] = useState(null);
  const [lastSocketMessage, setLastSocketMessage] = useState({});

  const scrollableDivRef = useRef(null);
  const prevMessagesLength = useRef(0);
  const isAtBottom = useRef(true);
  const wasAtBottomOnLastRender = useRef(true);
  const hasMarkedReadWhileAtBottom = useRef(false);

  const handleScroll = useCallback(() => {
    const element = scrollableDivRef.current;
    if (!element) return;

    const { scrollTop, scrollHeight, clientHeight } = element;
    const isAtBottomNow = scrollTop >= 0;
    const shouldShowButton = !isAtBottomNow && scrollHeight > clientHeight;

    setShowScrollToBottom(shouldShowButton);
    isAtBottom.current = isAtBottomNow;
    if (isAtBottomNow) setNewMessageCount(0);
  }, []);

  useEffect(() => {
    const element = scrollableDivRef.current;
    if (!element) return;

    element.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => element.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setLastSocketMessage(lastSocketConversationMessage);
  }, [lastSocketConversationMessage]);

  useEffect(() => {
    const checkScrollPosition = () => {
      const element = scrollableDivRef.current;
      if (!element) return;

      const { scrollTop, scrollHeight, clientHeight } = element;
      const isAtBottomNow = scrollTop >= 0;

      const shouldShowButton = !isAtBottomNow && scrollHeight > clientHeight;

      setShowScrollToBottom(shouldShowButton);
      isAtBottom.current = isAtBottomNow;

      const lastMessage = webChatConversationMessages[0];

      if (
        lastMessage?.team_member_id == selectedWebChatTeam?.team_member_id &&
        lastSocketMessage?.id &&
        lastSocketConversationMessage?.id &&
        lastSocketConversationMessage.id != lastSocketMessage.id
      ) {
        dispatch(
          updatedSelectedConversationLastReadMessageId({
            last_read_message_id: lastMessage.id,
          }),
        );
        setShowUnreadDivider(false);
        setUnreadDividerMessageId(null);
        setNewMessageCount(0);
        scrollToBottom();
      }
    };

    const timeoutId = setTimeout(checkScrollPosition, 100);
    return () => clearTimeout(timeoutId);
  }, [webChatConversationMessages.length]);

  useEffect(() => {
    if (webChatConversationMessages.length === 0) return;

    const hasUnread = webChatConversationMessages.some(
      (msg) => msg.id > last_read_message_id,
    );
    console.log({
      hasUnread,
      last_read_message_id,
      selectedWebChatConversation,
    });

    if (!hasUnread) {
      setShowUnreadDivider(false);
      setUnreadDividerMessageId(null);
      setNewMessageCount(0);
      return;
    }

    const unreadCount = webChatConversationMessages.filter(
      (msg) => msg.id > last_read_message_id,
    ).length;
    console.log({ unreadCount });

    const isInitialLoad = prevMessagesLength.current === 0;
    const newMessagesCount =
      webChatConversationMessages.length - prevMessagesLength.current;

    // console.log({
    //   isAtBottom: isAtBottom.current,
    //   newMessagesCount,
    //   isInitialLoad,
    //   prev_mes_cur: prevMessagesLength.current,
    //   cur_mess_count: webChatConversationMessages.length,
    // });

    // CASE 1: A new message arrives while the user is at the bottom.
    // Action: Mark as read and remove the divider.
    if (isAtBottom.current && newMessagesCount > 0 && !isInitialLoad) {
      MarkRead();
      setShowUnreadDivider(false);
      setUnreadDividerMessageId(null);
      setNewMessageCount(0);
    } else {
      // CASE 2: There are unread messages, but the user is not at the bottom
      // or it's the initial load.
      // Action: Show the divider if it's not already visible.

      console.log('else part');
      // console.log({
      //   isAtBottom: isAtBottom.current,
      //   newMessagesCount,
      //   isInitialLoad,
      //   prev_mes_cur: prevMessagesLength.current,
      //   cur_mess_count: webChatConversationMessages.length,
      // });

      if (!showUnreadDivider) {
        const lastReadIndex = webChatConversationMessages.findIndex(
          (msg) => msg.id === last_read_message_id,
        );

        if (lastReadIndex !== -1) {
          const afterLastReadMsg =
            lastReadIndex > 0
              ? webChatConversationMessages[lastReadIndex - 1]
              : webChatConversationMessages[0];
          setUnreadDividerMessageId(afterLastReadMsg?.id);
          setShowUnreadDivider(true);
        }
      }
      setNewMessageCount(unreadCount);
    }

    prevMessagesLength.current = webChatConversationMessages.length;
  }, [webChatConversationMessages.length, last_read_message_id]);

  const scrollToBottom = () => {
    const element = scrollableDivRef.current;
    if (!element) return;

    const shouldStopAtDivider = showUnreadDivider && newMessageCount > 0;

    if (shouldStopAtDivider) {
      const unreadElement = element.querySelector(
        `[data-unread-divider="true"]`,
      );
      if (unreadElement) {
        unreadElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Reset badge count as per requirement
        setNewMessageCount(0);
        return;
      }
    }

    // If divider isn't shown or badge is already 0, scroll to the bottom.
    element.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // 1. Use this At the time of User scrolled somewhere to top and a new message is received then clicked on the scrollToBottom button.
  // 2. when at the bottom and Every time a new message is received then use this.
  const MarkRead = () => {
    // console.log('Marking read');

    const params = {
      conversation_id: selectedWebChatConversation?.id,
      read_record_id,
      seen_message_id: lastMessageId,
      brand_id: currentBrand?.brand_id,
      team_id: selectedWebChatTeam?.team_id,
      channel_id: selectedWebChatTeam?.channel_id,
      sender_id: selectedWebChatTeam?.team_member_id,
    };
    // console.log({ params });

    sendReadEvent(params);

    dispatch(
      updatedSelectedConversationLastReadMessageId({
        last_read_message_id: lastMessageId,
      }),
    );
    prevMessagesLength.current = webChatConversationMessages.length;
    // setShowUnreadDivider(false);
    // setUnreadDividerMessageId(null);
    setNewMessageCount(0);
  };

  const sendTextMessage = (message) => {
    sendChatEvent(message);
  };

  const renderMessageWithUnreadDivider = (msg) => {
    const shouldShowUnreadDividerAfter =
      showUnreadDivider && unreadDividerMessageId === msg.id;

    return (
      <React.Fragment key={msg.id}>
        <ConversationMessage
          participantType={msg.participant_type}
          message={msg.message}
          timestamp={msg.created_at}
          status={msg.status}
          item={msg}
        />
        {shouldShowUnreadDividerAfter && (
          <div data-unread-divider="true">
            <WindowDivider title="Unread Messages" />
          </div>
        )}
      </React.Fragment>
    );
  };

  const nextFunc = () => {
    const nextPage = page + 1;
    const params = {
      brand_id: currentBrand?.brand_id,
      team_id: selectedWebChatTeam?.team_id,
      conversation_id: selectedWebChatConversation?.id,
      page: nextPage,
      limit: limit,
    };
    dispatch(fetchWebChatConversationMessages(params));
    setPage(nextPage);
  };

  useEffect(() => {
    if (webChatConversationMessages.length === 0) return;
    if (lastMessageId === last_read_message_id) return;
    if (!selectedWebChatConversation?.id || !lastMessageId) return;

    const params = {
      conversation_id: selectedWebChatConversation?.id,
      read_record_id,
      seen_message_id: lastMessageId,
      brand_id: currentBrand?.brand_id,
      team_id: selectedWebChatTeam?.team_id,
      channel_id: selectedWebChatTeam?.channel_id,
      sender_id: selectedWebChatTeam?.team_member_id,
    };

    sendReadEvent(params);
    dispatch(
      markTeamAsRead({
        team_id: selectedWebChatTeam?.team_id,
        conversation_id: selectedWebChatConversation?.id,
      }),
    );
    // dispatch(
    //   updatedSelectedConversationLastReadMessageId({
    //     last_read_message_id: lastMessageId,
    //   }),
    // );
    // setNewMessageCount(0);
    dispatch(markConversationAsRead());
  }, [selectedWebChatConversation?.id, lastMessageId]);

  useEffect(() => {
    setShowUnreadDivider(false);
    setUnreadDividerMessageId(null);
    setNewMessageCount(0);
    prevMessagesLength.current = 0;
    isAtBottom.current = true;
    wasAtBottomOnLastRender.current = true;
  }, [selectedWebChatConversation?.id]);

  return (
    <div className={`${className} grid grid-rows-7 w-full h-dvh`}>
      <ChatHeader className="min-h-[70px]" />
      <div
        className={`px-6 py-6 flex flex-col gap-4 relative row-span-7 ${
          webChatConversationMessages.length === 0 ? 'justify-center' : ''
        }`}
      >
        {showScrollToBottom && (
          <div
            className="absolute bottom-[0] left-1/2 transform -translate-x-1/2 z-50 cursor-pointer"
            onClick={scrollToBottom}
          >
            <Badge count={newMessageCount} showZero={false}>
              <div className="px-4 py-1 bg-gray-300 rounded-lg shadow-md hover:bg-gray-400 transition-colors">
                <DoubleLeftOutlined rotate={270} />
              </div>
            </Badge>
          </div>
        )}
        <div
          id="scrollableDivChatBox"
          ref={scrollableDivRef}
          onScroll={handleScroll}
          className="flex flex-col-reverse overflow-auto relative"
        >
          {webChatConversationMessages.length === 0 ? (
            webChatConversationMessagesLoading ? (
              <div>Loading</div>
            ) : (
              <NoData
                icon={ICONS?.inboxEmpty}
                title="There are no messages yet."
                iconStyle={'w-[10vw]'}
                style={'max-w-[25vw]'}
                titleClassName="!font-largest"
              />
            )
          ) : (
            <InfiniteScroll
              dataLength={webChatConversationMessages.length}
              next={nextFunc}
              hasMore={
                webChatMessagesCount > webChatConversationMessages.length
              }
              inverse={true}
              loader={
                <div className="m-auto my-2">
                  <LoadingOutlined style={{ fontSize: '32px' }} />
                </div>
              }
              style={{ display: 'flex', flexDirection: 'column-reverse' }}
              scrollableTarget="scrollableDivChatBox"
              className="gap-4"
            >
              {webChatConversationMessages?.map((msg, index) => {
                const showWindowDivider =
                  index > 0 &&
                  msg.web_chat_conversation_window_id !==
                    webChatConversationMessages[index - 1]
                      ?.web_chat_conversation_window_id;

                return (
                  <React.Fragment key={msg.id}>
                    {showWindowDivider && (
                      <WindowDivider title="New Conversation Window" />
                    )}
                    {renderMessageWithUnreadDivider(msg)}
                  </React.Fragment>
                );
              })}
              <WindowDivider title="Conversation Window Started" />
            </InfiniteScroll>
          )}
        </div>
      </div>
      <ChatBoxFooter onSend={sendTextMessage} />
    </div>
  );
};

export default ChatBox;

const WindowDivider = ({ title = 'New window started' }) => (
  <Divider>
    <Title
      style={{ marginBottom: '0px' }}
      level={5}
      type="secondary"
      className="rounded-lg p-2 bg-gray-200"
    >
      {title}
    </Title>
  </Divider>
);
